import {Icon} from '@adobe/react-spectrum';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHighlighter} from '@fortawesome/free-solid-svg-icons';

function Highlighter(props=null){
    return (
        <Icon {...props}>
            <FontAwesomeIcon icon={faHighlighter} />
        </Icon>
    );
}

export default Highlighter;